<template>
  <vs-row class="nav-options" style="width: auto">
    <div
      v-if="
        currentRoute === 'editor-personality' ||
        currentRoute === 'custom-editor-personality' ||
        currentRoute === 'editor-abilities-org'
      "
      class="editor-option"
    >
      <vx-tooltip
        text="Start Personality Tour"
        position="bottom"
        style="display: flex; align-items: baseline"
        class="items-center mr-3"
      >
        <vs-button
          radius
          class="editor-option personality-tour"
          size="small"
          color="lightgrey"
          type="flat"
          icon-pack="feather"
          icon="icon-info"
          @click.stop="startPersonalityTour()"
        ></vs-button>
      </vx-tooltip>
    </div>
    <vs-button
      :disabled="previousDisabled()"
      radius
      class="editor-option editor-move-previous mr-3"
      size="small"
      color="primary"
      type="flat"
      icon-pack="feather"
      icon="icon-arrow-left"
      @click.stop="previous()"
    ></vs-button>
    <vs-button
      :disabled="nextDisabled()"
      radius
      class="editor-option editor-move-next mr-3"
      size="small"
      color="success"
      type="flat"
      icon-pack="feather"
      icon="icon-arrow-right"
      @click.stop="next()"
    ></vs-button>
    <vs-button
      radius
      class="editor-option editor-move-close"
      size="small"
      color="#231D4F"
      type="flat"
      icon-pack="feather"
      icon="icon-x"
      @click.stop="showPreview()"
    ></vs-button>
  </vs-row>
</template>

<script>
import organizationConfig from "@/assets/data/organization-config.js";

export default {
  props: ["previousMove", "nextMove"],
  data() {
    return {
      organizationConfig,
    };
  },
  computed: {
    organizationId() {
      return this.$store.state.organization.orgData._id;
    },
    organizationSlug() {
      return this.$store.state.organization.organizationSlug;
    },
    editorTabs() {
      return this.organizationConfig[this.organizationSlug].editorTabs;
    },
    currentRoute() {
      return this.$route.name;
    },
  },
  methods: {
    convertEditorTabDictToArray() {
      let arr = [];
      Object.keys(this.editorTabs).forEach((key) => {
        arr.push(key);
      });
      return arr;
    },
    previousActiveRoute() {
      const currentRoute = this.$route.name;
      let editorTabsArr = this.convertEditorTabDictToArray(this.editorTabs);
      let currentRouteIndex = 0;
      for (let et = editorTabsArr.length; et >= 0; et--) {
        let editorTabKey = editorTabsArr[et];
        if (currentRoute.includes(editorTabKey)) {
          currentRouteIndex = et;
        }

        if (
          et < currentRouteIndex &&
          this.editorTabs[editorTabKey].active === true
        ) {
          return this.editorTabs[editorTabKey].routeName;
        }
      }
    },
    nextActiveRoute() {
      const currentRoute = this.$route.name;
      let editorTabsArr = this.convertEditorTabDictToArray(this.editorTabs);
      let currentRouteIndex = editorTabsArr.length;
      for (let et = 0; et < editorTabsArr.length; et++) {
        let editorTabKey = editorTabsArr[et];
        if (currentRoute.includes(editorTabKey)) {
          currentRouteIndex = et;
        }

        if (
          et > currentRouteIndex &&
          this.editorTabs[editorTabKey].active === true
        ) {
          return this.editorTabs[editorTabKey].routeName;
        }
      }
    },
    previous() {
      this.$router.push({ name: this.previousActiveRoute() });
    },
    previousDisabled() {
      if (
        this.$route.name === "editor-about" ||
        this.$route.name === "editor-about-custom" || 
        this.$route.name === "editor-about-org"
      ) {
        return true;
      }
      return false;
    },
    next() {
      this.$router.push({ name: this.nextActiveRoute() });
    },
    nextDisabled() {
      if (
        this.$route.name === "editor-projects" ||
        this.$route.name === "editor-projects-custom" ||
        this.$route.name === "editor-projects-org"
      ) {
        return true;
      }
      return false;
    },
    showPreview() {
      this.$store.dispatch("editor/toggleRightBar", false);
      if (this.organizationSlug === "default")
        this.$router.push({ name: "editor-preview" });
      else if (this.organizationSlug === "gala")
        this.$router.push({ name: "editor-preview-org" });
      else this.$router.push({ name: "editor-preview-custom" });
    },
    startPersonalityTour() {
      localStorage.removeItem("personalityTour");
      this.$emit("startPersonalityTour");
    },
  },
};
</script>

<style scoped>
.editor-move-previous {
  background: rgba(242, 147, 0, 0.1) !important;
  font-weight: 800;
}

.editor-move-next {
  background: rgba(68, 204, 136, 0.1) !important;
}

.personality-tour {
  background: #ffffff !important;
}

.editor-move-close {
  background: rgba(35, 29, 79, 0.1) !important;
}

.editor-option >>> .vs-icon {
  font-weight: 900 !important;
  font-size: 20px !important;
  border: none;
}

@media only screen and (max-width: 1200px) {
  .nav-options {
    display: none !important;
  }
}
</style>